import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

/**
 * Handles the `#session_id=…` fragment Emergent appends on OAuth return.
 * One-shot: exchange with backend, drop the fragment, then redirect to /tracker.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function AuthCallback() {
  const { exchangeGoogleSession } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      toast.error("Sign-in failed: no session returned.");
      navigate("/", { replace: true });
      return;
    }

    exchangeGoogleSession(sessionId)
      .then(() => {
        // Strip the fragment so a refresh won't retry an already-consumed id.
        window.history.replaceState(null, "", window.location.pathname);
        toast.success("Signed in with Google.");
        navigate("/tracker", { replace: true });
      })
      .catch((e) => {
        const msg = e?.response?.data?.detail || "Sign-in failed. Please try again.";
        toast.error(msg);
        navigate("/", { replace: true });
      });
  }, [exchangeGoogleSession, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center font-mono text-xs tracking-[0.3em] uppercase text-[#555] font-bold">
      Signing you in…
    </div>
  );
}
